// Props reach the renderers already checked against the shared Zod schemas, but typed
// loosely (`Record<string, unknown>`) because the schemas come from `@tutor/genui` at
// runtime. These readers narrow them without casts; a missing or odd value renders as
// nothing rather than throwing.

export type WidgetProps = Readonly<Record<string, unknown>>;

export function readString(props: WidgetProps, key: string): string | null {
  const value = props[key];
  return typeof value === "string" ? value : null;
}

export function readNumber(props: WidgetProps, key: string): number | null {
  const value = props[key];
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function readStrings(props: WidgetProps, key: string): readonly string[] {
  const value = props[key];
  if (!Array.isArray(value)) return [];
  return value.filter((entry): entry is string => typeof entry === "string");
}

export function readRecords(props: WidgetProps, key: string): readonly WidgetProps[] {
  const value = props[key];
  if (!Array.isArray(value)) return [];
  return value.filter(isRecord);
}

function isRecord(value: unknown): value is WidgetProps {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
